import React from "react";
import { useNavigate } from "react-router-dom";
import SmallBoxes from "../../../../Widgets/SmallBoxes/SmallBoxes";

export default function CityFilterWidget() {
  const [isMobile, setIsMobile] = React.useState(false);
  const navigate = useNavigate();

  React.useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkScreenSize();
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const handleBoxClick = (city) => {
    navigate(`/city/${city}`);
  };

  const handleAllProjectsClick = () => {
    navigate("/projects/all");
  };

  return (
    <div style={styles.container}>
      {/* Tüm Projeler Butonu */}
      <button
        onClick={handleAllProjectsClick}
        style={{
          ...styles.allProjectsButton,
          ...(isMobile && styles.mobileAllProjectsButton),
        }}
      >
        Tüm Projeleri Görüntüle
      </button>

      <div
        style={{
          ...styles.boxesContainer,
          ...(isMobile && styles.mobileBoxesContainer),
        }}
      >
        {/* İzmir */}
        <div
          style={{
            ...styles.box,
            ...(isMobile && styles.mobileBox),
            backgroundImage: `url("/images/HomePage/CityFilter/city_izmir.jpg")`,
            cursor: "pointer",
          }}
          onClick={() => handleBoxClick("izmir")}
        >
          <div style={styles.overlay}>
            <p style={{ ...styles.label, ...(isMobile && styles.mobileLabel) }}>
              İzmir
            </p>
          </div>
        </div>

        {/* Ankara */}
        <div
          style={{
            ...styles.box,
            ...(isMobile && styles.mobileBox),
            backgroundImage: `url("/images/HomePage/CityFilter/city_ankara.jpg")`,
            cursor: "pointer",
          }}
          onClick={() => handleBoxClick("ankara")}
        >
          <div style={styles.overlay}>
            <p style={{ ...styles.label, ...(isMobile && styles.mobileLabel) }}>
              Ankara
            </p>
          </div>
        </div>

        {/* İstanbul */}
        <div
          style={{
            ...styles.box,
            ...(isMobile && styles.mobileBox),
            backgroundImage: `url("/images/HomePage/CityFilter/city_istanbul.jpg")`,
            cursor: "pointer",
          }}
          onClick={() => handleBoxClick("istanbul")}
        >
          <div style={styles.overlay}>
            <p style={{ ...styles.label, ...(isMobile && styles.mobileLabel) }}>
              İstanbul
            </p>
          </div>
        </div>
      </div>

      <SmallBoxes />
    </div>
  );
}

const styles = {
  container: {
    width: "100%",
    padding: "60px 0",
    backgroundColor: "#fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
  },
  boxesContainer: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    maxWidth: "1300px",
    flexWrap: "wrap",
    gap: "30px",
    marginTop: "30px",
  },
  box: {
    position: "relative",
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    padding: "40px",
    flex: "1 1 calc(33.333% - 20px)",
    minHeight: "200px",
    textAlign: "center",
    boxSizing: "border-box",
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "center",
    transition: "transform 0.2s ease-in-out",
  },
  overlay: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "12px",
  },
  label: {
    fontSize: "20px",
    fontWeight: "600",
    color: "#fff",
    margin: 0,
  },
  allProjectsButton: {
    marginBottom: "10px",
    padding: "17px 38px",
    backgroundColor: "#FFC107", // sarı
    color: "#001E78", // lacivert
    border: "none",
    borderRadius: "24px",
    fontSize: "19px",
    fontWeight: "700",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "10px",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 15px rgba(255, 193, 7, 0.4)",
    userSelect: "none",
  },
  mobileBoxesContainer: {
    gap: "18px",
    padding: "0 12px",
    justifyContent: "center",
  },
  mobileBox: {
    flex: "0 0 90%", // kutular ekranın %80’i kadar
    minHeight: "140px",
    padding: "20px",
    margin: "0 auto",
    borderRadius: "10px",
  },
  mobileLabel: {
    fontSize: "16px",
  },
  mobileAllProjectsButton: {
    padding: "12px 24px",
    fontSize: "16px",
    marginBottom: "20px",
  },
};
